
import { logger } from '@/utils/logger';

/**
 * Clean content to remove images and metadata
 */
export function cleanContent(content: string): string {
  return content
    .replace(/!\[.*?\]\(.*?\)/g, '') // Remove markdown images
    .replace(/<img.*?>/g, '')        // Remove HTML images
    .replace(/<meta.*?>/g, '');      // Remove meta tags
}

/**
 * Log request details for debugging purposes
 */
export function logRequestDetails(
  apiKey: string | undefined,
  model: string,
  temperature: number,
  maxTokens: number,
  responseFormat: string | object | undefined
): void {
  logger.info('FAQ request details', {
    context: {
      apiKeyValid: !!apiKey && apiKey.startsWith('sk-') && apiKey.length > 20,
      apiKeyLength: apiKey?.length || 0,
      model,
      temperature,
      maxTokens,
      responseFormat: typeof responseFormat === 'string' ? responseFormat : 'json_object'
    }
  });
  
  console.log('FAQ API request details:');
  console.log('API Key available:', !!apiKey);
  if (apiKey) {
    console.log('API Key format valid:', apiKey.startsWith('sk-'));
    console.log('API Key length:', apiKey.length);
    console.log('API Key first 5 chars:', apiKey.substring(0, 5));
  }
  console.log(`Model: ${model}`);
  console.log(`Temperature: ${temperature}`);
  console.log(`Max tokens: ${maxTokens}`);
  console.log(`Response format: ${typeof responseFormat === 'string' ? responseFormat : 'json_object'}`);
}
